export default {
  article: {
  metaTitle: 'AllChinaBuy Spreadsheet: Complete Guide to Finds, QC & Smart Shopping',
  metaDescription:
    'A complete, independent guide to the AllChinaBuy spreadsheet — how it works, how to use it step by step, QC tips and shipping cost basics.',
  title: 'AllChinaBuy Spreadsheet: The Complete Guide to Product Finds, QC & Smart Shopping',
  intro:
    'An AllChinaBuy spreadsheet is a shareable, organized list of product finds — links, QC photos, seller notes and shipping hints — that helps you browse and buy with more confidence. On this page we explain how a good spreadsheet works, how to use one step by step, and what to watch for before you check out. This is an independent guide, not an official AllChinaBuy page.',
  h2_what: 'What Is an AllChinaBuy Spreadsheet?',
  p_what_1:
    'At its simplest, an AllChinaBuy spreadsheet is a curated table of items that other buyers have already found and, in many cases, already ordered. Each row usually includes the product link, a short description, the price, the seller or shop, and sometimes a QC (quality control) photo that shows what actually arrived at the warehouse.',
  p_what_2:
    'The value is in the filtering. Instead of scrolling through endless store pages, you open the spreadsheet, sort by category, and jump straight to items that fit your style and budget. Many spreadsheets also mark whether an item has been reviewed, so you can skip the guesswork.',
  h2_why: 'Why Use a Spreadsheet for Your Finds?',
  p_why_1:
    'Shopping through an agent involves more steps than a normal checkout, so anything that reduces friction helps. A well-maintained spreadsheet turns hours of browsing into minutes of comparing.',
  l_why_1: 'Save time — curated links mean less searching.',
  l_why_2: 'Fewer mistakes — you see QC photos before committing.',
  l_why_3: 'Better value — compare similar items side by side.',
  l_why_4: 'Clearer decisions — categories and notes keep everything organized.',
  h2_how: 'How to Use the Spreadsheet Step by Step',
  p_how_1:
    'You do not need any special software. A spreadsheet opens in a browser, on a phone, or in a spreadsheet app. Here is a simple workflow.',
  step_1: 'Open the spreadsheet and choose a category, such as Shoes or Hoodies.',
  step_2: 'Scan the list and shortlist a few items that match your taste and budget.',
  step_3: 'Check the QC photos and seller notes before you decide.',
  step_4: 'Copy the product link into your agent and start your order.',
  h2_categories: 'Categories You Can Browse',
  p_categories_1:
    'The most useful spreadsheets organize items into clear categories. Below are the main categories covered, each linking to a dedicated page with curated finds.',
  h2_qc: 'Quality Control (QC) Tips',
  p_qc_1:
    'QC photos are the most underrated part of the process. They show what actually arrived, not the polished store photo. Before you ship, check:',
  qc_1: 'Color and logo placement match the listing.',
  qc_2: 'No obvious stitching or glue issues.',
  qc_3: 'Size and material look correct for your order.',
  h2_shipping: 'Understanding Shipping Costs',
  p_shipping_1:
    'Shipping cost depends mainly on weight, parcel size and the line you choose. Heavier items like jackets or shoes cost more than light accessories. Always compare lines and consider consolidating items into one parcel to save money.',
  h2_faq: 'Frequently Asked Questions',
  faq_q1: 'Is this an official AllChinaBuy website?',
  faq_a1:
    'No. This is an independent information resource. We are not affiliated with or endorsed by AllChinaBuy. Always verify product, seller, payment and shipping details before buying.',
  faq_q2: 'Do I need the spreadsheet to shop?',
  faq_a2:
    'No, but it saves a lot of time. A good spreadsheet gives you curated links and QC photos you would otherwise have to find yourself.',
  faq_q3: 'How much does shipping cost?',
  faq_a3:
    'It varies by weight, size and shipping line. Light items cost less, and consolidating parcels usually reduces the total.',
  cta_title: 'Ready to Find Your Next Product?',
  cta_text: 'Browse the curated categories and start your next order with more confidence.',
  backHome: 'Back to Home',
  readMoreHome: 'Return to the homepage to explore all categories and guides.',
  },
};